import { createSelector } from 'reselect';
import { escapeRegExp } from '@zedoc/text';
import { selectQueryParam } from '../../router';

export const getSearchPhrase = selectQueryParam('search');
export const getSearchRegEx = createSelector(
  getSearchPhrase,
  (search) => search && new RegExp(escapeRegExp(search), 'i'),
);
